import { render, staticRenderFns } from "./DeliveryDetailCard.vue?vue&type=template&id=dff2ecee&scoped=true&"
import script from "./DeliveryDetailCard.vue?vue&type=script&lang=js&"
export * from "./DeliveryDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryDetailCard.vue?vue&type=style&index=0&id=dff2ecee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff2ecee",
  null
  
)

export default component.exports